import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'

const transition: Transition = {
  duration: 0.5,
  type: 'spring',
  bounce: 0.3,
}

export const PlusSquares = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      whileHover="hover"
      fill="none"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      {/* Squares */}
      {/* Top left */}
      <motion.path
        transition={transition}
        initial={{ x: 0, opacity: 0 }}
        variants={{ hover: { x: 7.5, opacity: 1 } }}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M3.75 7.5c0 .173.029.319.095.479.066.159.149.283.27.405.123.122.247.205.406.271.16.066.306.095.479.095h2.5c.172 0 .319-.029.478-.095.16-.066.284-.149.406-.271.122-.122.205-.246.27-.405.067-.16.096-.306.096-.479V5c0-.173-.03-.319-.095-.478a1.189 1.189 0 0 0-.271-.406 1.189 1.189 0 0 0-.406-.27A1.191 1.191 0 0 0 7.5 3.75H5c-.173 0-.32.03-.479.095-.16.066-.283.15-.405.271a1.189 1.189 0 0 0-.271.406c-.066.16-.095.305-.095.478v2.5Z"
      />

      {/* Top right */}
      <motion.path
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { y: 7.5 } }}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M11.25 7.5c0 .173.029.319.095.479.066.159.149.283.27.405.123.122.247.205.406.271.16.066.306.095.479.095H15c.172 0 .319-.029.478-.095.16-.066.284-.149.406-.271.122-.122.205-.246.27-.405.067-.16.096-.306.096-.479V5c0-.173-.03-.319-.095-.478a1.189 1.189 0 0 0-.271-.406 1.189 1.189 0 0 0-.406-.27A1.191 1.191 0 0 0 15 3.75h-2.5c-.173 0-.32.03-.479.095-.16.066-.283.15-.405.271a1.189 1.189 0 0 0-.271.406c-.066.16-.095.305-.095.478v2.5Z"
      />

      {/* Bottom right */}
      <motion.path
        transition={transition}
        initial={{ x: 0 }}
        variants={{ hover: { x: -7.5 } }}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M11.25 15c0 .173.029.319.095.479.066.159.149.283.27.405.123.122.247.205.406.271.16.066.306.095.479.095H15c.172 0 .319-.029.478-.095.16-.066.284-.149.406-.271.122-.122.205-.246.27-.405.067-.16.096-.306.096-.479v-2.5c0-.172-.03-.319-.095-.478a1.189 1.189 0 0 0-.271-.406 1.189 1.189 0 0 0-.406-.27A1.191 1.191 0 0 0 15 11.25h-2.5c-.173 0-.32.03-.479.095-.16.066-.283.15-.405.271a1.189 1.189 0 0 0-.271.406c-.066.16-.095.306-.095.478V15Z"
      />

      {/* Bottom left */}
      <motion.path
        transition={transition}
        initial={{ y: 0, opacity: 1 }}
        variants={{ hover: { y: -7.5, opacity: 0 } }}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M3.75 15c0 .173.029.319.095.479.066.159.149.283.27.405.123.122.247.205.406.271.16.066.306.095.479.095h2.5c.172 0 .319-.029.478-.095.16-.066.284-.149.406-.271.122-.122.205-.246.27-.405.067-.16.096-.306.096-.479v-2.5c0-.172-.03-.319-.095-.478a1.189 1.189 0 0 0-.271-.406 1.189 1.189 0 0 0-.406-.27 1.191 1.191 0 0 0-.478-.096H5c-.173 0-.32.03-.479.095-.16.066-.283.15-.405.271a1.189 1.189 0 0 0-.271.406c-.066.16-.095.306-.095.478V15Z"
      />

      {/* Plus */}
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M8.437 6.272H4.062"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M6.25 4.084V8.46"
      />
    </motion.svg>
  )
}
